var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAiResponseIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 10 10",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8380_17738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.83361 4.74539C8.15153 4.01701 5.97563 1.86703 5.24847 0.166433C5.15341 -0.0557863 4.84107 -0.055169 4.74539 0.166433C4.01701 1.84851 1.86703 4.02441 0.166433 4.75157C-0.0557863 4.84663 -0.055169 5.15897 0.166433 5.25465C1.84851 5.98303 4.02441 8.13301 4.75157 9.83361C4.84663 10.0558 5.15897 10.0552 5.25465 9.83361C5.98303 8.15153 8.13301 5.97563 9.83361 5.24847C10.0558 5.15341 10.0552 4.84107 9.83361 4.74539Z",
    fill: "current"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiResponseIcon);
export default __webpack_public_path__ + "static/media/AIResponseIcon.a23e37262efd38459ca2dc27c4ee6ee3.svg";
export { ForwardRef as ReactComponent };